import React from "react";
import PropTypes from "prop-types";
import GenericTable from "../genericTable";

const ToggleButton = (props) => {
  const {
    name,
    value,
    label,
    idx,
    onChange
  } = props;


  return (
    <button name={name} className='tes-button' value={(value) ? value : idx} onClick={(e) => {onChange();}}>{label}</button>
  );
}

ToggleButton.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.any,
  idx: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired
}

export default ToggleButton;